import { alpha, Components, Theme } from "@mui/material";

export const MuiButton: Components<Theme>["MuiButton"] = {
  defaultProps: {
    disableRipple: true,
    variant: "contained",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      fontSize: theme.typography.fontSize,
      textTransform: "none",
    }),

    text: ({ theme }) => ({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    }),
  },
  variants: [
    {
      props: (props) => props.variant === "iconOnlyOutlined",
      style: ({ theme }) => ({
        textTransform: "none",
        color: theme.palette.primary.main,
        border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`,
        "& .MuiButton-startIcon": {
          margin: 0,
        },
      }),
    },
    {
      props: (props) => props.variant === "denseUnderlined",
      style: ({ theme }) => ({
        textTransform: "none",
        color: theme.palette.action.active,
        marginRight: theme.spacing(0),
        padding: "0px",
        ":hover": {
          background: "none",
          textDecoration: "underline",
        },
        "& .MuiButton-startIcon": {
          marginRight: theme.spacing(0.5),
        },
        "& .MuiButton-endIcon": {
          marginRight: theme.spacing(0),
        },
      }),
    },
    {
      props: { variant: "denseUnderlined", color: "info" },
      style: ({ theme }) => ({
        textTransform: "none",
        color: theme.palette.info.main,
        padding: "0px",
        marginRight: theme.spacing(0),
        ":hover": {
          background: "none",
          textDecoration: "underline",
        },
        "& .MuiSvgIcon-root": {
          fontSize: theme.typography.pxToRem(14),
        },
        "& .MuiButton-endIcon": {
          marginRight: theme.spacing(0),
        },
      }),
    },
    {
      props: { variant: "denseUnderlined", color: "error" },
      style: ({ theme }) => ({
        textTransform: "none",
        color: theme.palette.error.main,
        padding: "0px",
        marginRight: theme.spacing(0),
        ":hover": {
          background: "none",
          textDecoration: "underline",
        },
        "& .MuiSvgIcon-root": {
          fontSize: theme.typography.pxToRem(14),
        },
        "& .MuiButton-endIcon": {
          marginRight: theme.spacing(0),
        },
      }),
    },
  ],
};
